export enum ResponseStatusCodes {
  AUTH_ERROR = 401,
}
